<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M192 224C192 153.3 249.3 96 320 96C390.7 96 448 153.3 448 224C448 277.5 415.2 323.3 368.5 342.5C337.4 355.3 304 383.5 304 424L304 448C304 456.8 311.2 464 320 464C328.8 464 336 456.8 336 448L336 424C336 402.7 354.5 382.8 380.7 372.1C438.9 348.2 480 290.9 480 224C480 135.6 408.4 64 320 64C231.6 64 160 135.6 160 224C160 232.8 167.2 240 176 240C184.8 240 192 232.8 192 224zM320 576C333.3 576 344 565.3 344 552C344 538.7 333.3 528 320 528C306.7 528 296 538.7 296 552C296 565.3 306.7 576 320 576z"
      fill="currentColor"
    />
  </svg>
</template>